import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IAuditGridModel, IAuditModel, IAuditSearchRecordModel, actionsAuditList } from '@shared/models/audit.model';
import {
  ILocationPoint,
} from '@types-custom/models/business/location.model';
import {
  AbstractPaginatorDataSource,
  IPaginatorModel,
} from '@types-custom/models/ui/paginator-model';

import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable()
export class GridAuditRecordService implements
  AbstractPaginatorDataSource<any>
{
  selected$ = new BehaviorSubject<any | undefined>(undefined);
  private dataSubject = new BehaviorSubject<IAuditGridModel[]>([]);
  data$ = this.dataSubject.asObservable();
  pageInfo = new BehaviorSubject<IPaginatorModel>({ page: 0, pageSize: 10 });
  selectedData!: BehaviorSubject<ILocationPoint<string> | undefined>;

  auditSelected$ = new BehaviorSubject<IAuditModel | undefined>(undefined);

  constructor(
    @Inject('environment') private environment: any,
    private httpClient: HttpClient
  ) { }

  fetchPageDataDistpacher(selectedData: any) {
    const dataObject: IPaginatorModel = {
      page: 0,
      pageSize: 20,
      data: selectedData,
    };
    this.fetchPageData(dataObject).subscribe();
  }

  setSelectedDataSubject(
    selectedData: BehaviorSubject<ILocationPoint<string> | undefined>
  ): void {
    this.selectedData = selectedData;
    this.selectedData.subscribe((selectedData) =>
      this.fetchPageDataDistpacher(selectedData)
    );
  }

  buildUrl(dataObject: IPaginatorModel): string {
    const data: IAuditSearchRecordModel = this.auditSelected$.getValue()?.data;
    let url: string;
    url = `${this.environment.auditUrl}/audit/${this.auditSelected$.getValue()?.code}/pagination/data-record?entityId=${data.id}&recordsPerPage=${dataObject.pageSize}&page=${dataObject.page}`;
    return url;
  }

  fetchPageData(pageInfo: IPaginatorModel): Observable<IPaginatorModel> {
    pageInfo.data = this.selectedData.value;
    const url = this.buildUrl(pageInfo);
    return this.httpClient
      //.get<any>(`/assets/mock/audit/grid-audit-record.json`)
      .get<any>(url)
      .pipe(
        tap((response: any) => {
          const _pageInfo: IPaginatorModel = {
            page: response.currentPage,
            pageSize: pageInfo.pageSize,
            totalCount: response.totalRecords,
          };
          this.pageInfo.next(_pageInfo);
        }),
        tap((response: any) => {
          const data: IAuditGridModel[] = response.records.map(
            (item: IAuditGridModel) => {
              item.auditType = this.getNameAction(item.auditType);
              return item;
            }
          );

          this.dataSubject.next(data ?? []);
        }),
        tap((response: any) => {
          const data: any[] = response.records;
          this.dataSubject.next(data ?? []);
        })
      );
  }

  public init() {
    this.setSelectedDataSubject(this.selected$);
  }

  public getUser(params: any): Observable<any> {
    const url = `${this.environment.auditUrl}/user/`;
    return this.httpClient.get<any>(url, { params: params });
  }

  public getDataSelected(entityType: string, entityId: string, entityRevId: number): Observable<any> {
    const url = `${this.environment.auditUrl}/audit/${entityType}/${entityId}/?entityRevId=${entityRevId}`;
    return this.httpClient
    //.get<any>(`/assets/mock/audit/grid-audit-${type}-selected.json`)
    .get<any>(url)
    ;
  }

  public searhAfterSave(): void {
    this.setSelectedDataSubject(this.selected$);
  }

  public setModelAudit(model: IAuditModel) {
    this.auditSelected$.next(model);
  }

  private getNameAction(code: string): string {
    const itemSession = actionsAuditList.find(
      (item) => item.value === code
    );
    return itemSession ? itemSession.label : code;
  }

  buildExcelUrl(entityType: string, entityId: string) {
    let url = `${this.environment.auditUrl}/audit/${entityType}/export/excel/data-record?entityId=${entityId}`;
    return url;
  }

}
